const SOCKET_NAMESPACES = Object.freeze({
  POKER_GAME: '/poker-game',
  USER: '/user',
  LOBBY: '/lobby',
  WALLET: '/wallet'

})

export default SOCKET_NAMESPACES
